import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { MarkerType } from 'types/marker';

interface MarkersPayload extends Omit<PayloadAction, 'payload'> {
  payload: { markers: MarkerType[] };
}

interface MarkerPayload extends Omit<PayloadAction, 'payload'> {
  payload: { marker: MarkerType };
}

const initialValue: MarkerType[] = [];

export const markersSlice = createSlice({
  name: 'markers',
  initialState: {
    value: initialValue,
  },
  reducers: {
    add: (state, action: MarkerPayload) => {
      const { marker } = action.payload;
      state.value = [
        ...state.value,
        {
          id: marker.id,
          title: marker.title,
          description: marker.description,
          latlng: marker.latlng,
          image: marker.image,
          markerIcon: marker.markerIcon,
        },
      ];
    },
    change: (state, action: MarkerPayload) => {
      const { marker } = action.payload;
      state.value = state.value.map((m) => {
        if (m.id === marker.id) {
          return marker;
        } else {
          return m;
        }
      });
    },
    remove: (state, action: { payload: { id: string } }) => {
      const { id } = action.payload;
      state.value = state.value.filter((m) => m.id !== id);
    },
    replace: (state, action: MarkersPayload) => {
      state.value = action.payload.markers;
    },
  },
});

// Action creators are generated for each case reducer function
export const { add, change, remove, replace } = markersSlice.actions;
export const selectAllMarkers = (state) => state.markers;

export default markersSlice.reducer;
